import { LoadCompanies } from 'entities/company/company.actions';
import type { ActionsObservable } from 'redux-observable';
import { ofType } from 'redux-observable';
import { concat, of } from 'rxjs';
import { catchError, exhaustMap, map, mergeMap } from 'rxjs/operators';
import type { LoginRequest, LogoutRequest } from './auth.actions';
import { AuthActionsTypes, LoginFailure, LoginSuccess, LogoutFailure, LogoutSuccess } from './auth.actions';
import type { LoginError } from './auth.models';
import { requestAccessToken, requestLogout } from './auth.service';

export const handleLoginRequest = (action$: ActionsObservable<ReturnType<typeof LoginRequest>>) =>
  action$.pipe(
    ofType(AuthActionsTypes.LOGIN_REQUEST),
    map(action => action.payload),
    exhaustMap((code: string) =>
      requestAccessToken(code).pipe(
        map(response => {
          const token = response.data;
          localStorage.setItem('access_token', token.access_token);
          localStorage.setItem('refresh_token', token.refresh_token);

          return LoginSuccess(token);
        }),
        catchError((error: LoginError) => of(LoginFailure(error)))
      )
    )
  );

export const handleLogoutRequest = (action$: ActionsObservable<ReturnType<typeof LogoutRequest>>) =>
  action$.pipe(
    ofType(AuthActionsTypes.LOGOUT_REQUEST),
    exhaustMap(() =>
      requestLogout().pipe(
        map(() => {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          sessionStorage.removeItem('access_token');
          sessionStorage.removeItem('refresh_token');
          sessionStorage.removeItem('company_id');

          return LogoutSuccess();
        })
      )
    ),
    catchError((error: LoginError) => of(LogoutFailure(error)))
  );

export const handleLoginSuccess = (action$: ActionsObservable<ReturnType<typeof LoginSuccess>>) =>
  action$.pipe(
    ofType(AuthActionsTypes.LOGIN_SUCCESS),
    mergeMap(() =>
      concat([
        LoadCompanies({
          pageable: {
            page: 0,
            size: 10
          }
        })
      ])
    )
  );
